export default "__VITE_ASSET__1kFwv9omqY3_JFhTJAYRvg__"